import * as ErrorLogConstants from './ErrorLogConstants'

let initialState = {

    activeErrorItem: {},
    activeErrorItemIndex:null
}
const createSchoolInformationReducer = (state = initialState, action) => {
    switch (action.type) {
        case ErrorLogConstants.SET_ACTIVE_ERROR:
            return { ...state, activeErrorItem: action.data, activeErrorItemIndex: action.index }
        default:
            return state;
    }
}
export default createSchoolInformationReducer;